export default "__VITE_ASSET__DMqTvwtU__"